import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Sales } from '../../utils/formNames';
import { getFormData } from '../../utils/sessionStorage';
import { FORM_HOST } from '../../utils/constants';
import EnrollmentForm from './EnrollmentForm';
import EnrollmentFormCheckboxBlockInput from '../FormInputs/FormCheckboxBlockInput';
import EnrollmentFormError from '../FormInputs/FormError';

const formName = Sales;
const pardotFormUrl = `${FORM_HOST}/l/772833/2020-07-23/7tnf4y`;
const callbackLocations = {
  success_location: `${FORM_HOST}/l/772833/2020-07-23/7tnf73/772833/61418/sales_success.js`,
  error_location: `${FORM_HOST}/l/772833/2020-07-23/7tnf71/772833/61416/sales_error.js`,
};

const SalesForm = () => {
  const { register, handleSubmit, formState, triggerValidation, errors } = useForm({
    mode: 'onChange',
    submitFocusError: false,
  });

  const previousData = getFormData(formName);

  // Necessary because react-hook-form has a bug
  // regarding default values on required radio inputs
  useEffect(() => {
    if (previousData.desired_sales_industries) {
      triggerValidation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <EnrollmentForm
      formName={formName}
      callbackLocations={callbackLocations}
      actionUrl={pardotFormUrl}
      formValid={formState.isValid}
      validationHandler={handleSubmit}
    >
      <legend>Sales</legend>
      <p>What industries do you prefer for your next job?</p>
      <div className="blockInputs">
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="technology"
          label="Technology / Software"
          value="Technology, Software, or IT"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="realestate"
          label="Real Estate"
          value="Real Estate"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="insurance"
          label="Insurance"
          value="Insurance"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="financial_services"
          label="Financial Services"
          value="Securities, Commodities, and Financial Services"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="manufacturing"
          label="Wholesale and Manufacturing"
          value="Wholesale and Manufacturing"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="advertising"
          label="Advertising"
          value="Advertising"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="medical"
          label="Medical Device, Pharmaceutical, or Healthcare"
          value="Medical Device, Pharmaceutical, or Healthcare"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="hospitality"
          label="Travel, Events, or Hospitality"
          value="Travel, Events, or Hospitality"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="retails"
          label="Retail"
          value="Retail"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="automotive"
          label="Automotive"
          value="Automotive"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="recruitment"
          label="Recruitment"
          value="Recruitment"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="entertainment"
          label="Entertainment, Sports, or Music"
          value="Entertainment, Sports, or Music"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="transportation"
          label="Transportation"
          value="Transportation"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="food"
          label="Food & Beverage"
          value="Food & Beverage"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="telecom"
          label="Telecommunication"
          value="Telecommunication"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="consulting"
          label="Consulting Services"
          value="Consulting Services"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
        <EnrollmentFormCheckboxBlockInput
          name="desired_sales_industries"
          id="no_preference"
          label="Any / No Preference"
          value="Any / No Preference"
          defaultValue={previousData.desired_sales_industries}
          inputRef={register({ required: true })}
        />
      </div>
      <EnrollmentFormError errorField={errors.desired_sales_industries} blockError />
    </EnrollmentForm>
  );
};

export default SalesForm;
